const getBaseUrlFrontend = () => {
    if (!process.env.NEXT_PUBLIC_FRONTEND_URL) {
        throw new Error("FRONTEND_URL is not set");
    }
    return process.env.NEXT_PUBLIC_FRONTEND_URL;
}

const getBaseUrlBackend = () => {
    if (!process.env.NEXT_PUBLIC_BACKEND_URL) {
        throw new Error("BACKEND_URL is not set");
    }
    return process.env.NEXT_PUBLIC_BACKEND_URL;
}

export {
    getBaseUrlBackend, getBaseUrlFrontend
};
